import AddIcon from '@mui/icons-material/Add';
import { Box, Grid } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Cell } from 'react-table';
import { getOurEntityTaxationList, OurEntityTaxation } from 'wisestep-api';
import {
  WsButton,
  WsDataTable,
  WsElementWithPopOver,
  WsIconEdit,
  WsIconMoreVer,
} from 'wisestep-base';

import IconTextLink from '../../../components/IconTextLink';
import { useDrawer } from '../../../hooks/useDrawer';

import { OurEntityTaxationForm, withLabelTaxType } from './OurEntityTaxationForm';

export const ShowOurEntityTaxation = ({ ourEntityId }: { ourEntityId: string }) => {
  const [openDrawer, closeDrawer] = useDrawer();
  const [ourEntityTaxationList, setOurEntityTaxationList] = useState<OurEntityTaxation[]>([]);

  const fetch = useCallback(
    () =>
      getOurEntityTaxationList(ourEntityId).then((response) =>
        setOurEntityTaxationList(response.data)
      ),
    [ourEntityId]
  );

  useEffect(() => {
    fetch();
  }, [fetch]);

  const openTaxationDrawer = (defaultValues?) => {
    openDrawer({
      children: (
        <OurEntityTaxationForm
          defaultValues={defaultValues}
          ourEntityId={ourEntityId}
          onSave={() => {
            fetch();
            closeDrawer();
          }}
          onClose={closeDrawer}
        />
      ),
      props: {
        title: 'Add Taxation',
      },
    });
  };

  return (
    <Box borderRadius={1.5}>
      <Grid>
        <Grid item xs={12} display="flex" justifyContent="flex-end" pt={2} pb={2} columnGap={2}>
          <WsButton
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => openTaxationDrawer()}
          >
            Add Taxation
          </WsButton>
        </Grid>
        <WsDataTable
          columns={[
            {
              Header: 'Location',
              accessor: 'location',
              Cell: (cell: Cell) => {
                const location = cell.row.original['location'];
                return [location.state, location.country].filter((x) => x).join();
              },
            },
            {
              Header: 'Taxation Type',
              accessor: 'taxType.name',
            },
            {
              Header: 'Taxation Rate',
              accessor: (row) => `${(row as unknown as OurEntityTaxation).taxType.rate}%`,
            },
            {
              Header: 'Created By',
              accessor: 'createdByName',
            },
            {
              Header: '',
              accessor: 'Action',
              Cell: (cell: Cell) => (
                <WsElementWithPopOver element={<WsIconMoreVer />}>
                  <Grid p={2} columnGap={1}>
                    <IconTextLink
                      text="Edit"
                      onClick={() =>
                        openTaxationDrawer({
                          ...cell.row.original,
                          taxType: withLabelTaxType(
                            (cell.row.original as OurEntityTaxation).taxType
                          ),
                        })
                      }
                      icon={<WsIconEdit />}
                    />
                  </Grid>
                </WsElementWithPopOver>
              ),
            },
          ]}
          data={ourEntityTaxationList as []}
          boldItems={['name']}
        />
      </Grid>
    </Box>
  );
};
